import React, { useState, useEffect } from 'react';
import './App.css';

// Import Firebase initialization first
import './firebase/init';
import { auth, db } from './firebase/config';
import { onAuthStateChanged } from 'firebase/auth';
import { collection, query, where, getDocs } from 'firebase/firestore';

// Import components
import BillPlannerWrapper from './components/BillPlannerWrapper';
import Login from './components/Login';
import WorkspaceMigration from './components/WorkspaceMigration';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [workspaceId, setWorkspaceId] = useState(null);

  // Other user's ID
  const otherUserId = 'phSz1Gghi4WifWjHWtA7LoeYd2q1';

  // Find user's workspace
  const findUserWorkspace = async (userId) => {
    console.log('Finding workspace for user:', userId);
    try {
      const workspacesRef = collection(db, 'workspaces');
      const q = query(workspacesRef, where('members', 'array-contains', userId));
      const querySnapshot = await getDocs(q);
      
      console.log('Found workspaces:', querySnapshot.size);
      
      if (!querySnapshot.empty) {
        // Use the first workspace found
        const workspace = querySnapshot.docs[0];
        console.log('Setting workspace ID:', workspace.id);
        setWorkspaceId(workspace.id);
      } else {
        console.log('No workspace found');
        setWorkspaceId(null);
      }
    } catch (error) {
      console.error('Error finding workspace:', error);
      setError(error.message);
    }
  };

  useEffect(() => {
    let unsubscribe;
    try {
      const handleAuth = async (user) => {
        console.log('Auth state changed:', user?.uid);
        setUser(user);
        if (user) {
          await findUserWorkspace(user.uid);
        }
        setLoading(false);
      };

      unsubscribe = onAuthStateChanged(auth, handleAuth);
    } catch (error) {
      console.error('Auth initialization error:', error);
      setError(error.message);
      setLoading(false);
    }

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, []);

  console.log('Current state:', { user: !!user, loading, error, workspaceId });

  if (error) {
    return (
      <div className="error-container">
        <h1>Error</h1>
        <p>{error}</p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // Render the appropriate component based on state
  let content;
  if (!user) {
    content = <Login />;
  } else if (!workspaceId) {
    content = (
      <WorkspaceMigration 
        userId={user.uid} 
        otherUserId={otherUserId}
        onWorkspaceCreated={(id) => {
          console.log('Workspace created:', id);
          setWorkspaceId(id);
        }}
      />
    );
  } else {
    content = <BillPlannerWrapper userId={user.uid} workspaceId={workspaceId} />;
  }

  return (
    <div className="app">
      {content}
    </div>
  );
}

export default App;
